import { RefreshCw, X } from 'lucide-react';
import { Button } from '@lean-agility/design-system/react';

interface UpdateNotificationProps {
  /** Clear caches and reload to pick up the new bundle. */
  onReload: () => void;
  /** Dismiss the banner for the current detected version. */
  onDismiss: () => void;
}

/**
 * In-flow banner shown when a newer app version has been deployed than the one
 * running in this tab. Prompts the user to reload. Styled with semantic design
 * tokens so it tracks the theme in both light and dark mode.
 */
export function UpdateNotification({ onReload, onDismiss }: UpdateNotificationProps) {
  return (
    <div className="mx-auto w-full max-w-450 px-4 pt-4" data-testid="update-notification">
      <div className="flex items-center gap-3 rounded-lg bg-action-primary px-4 py-3 shadow-lg">
        <RefreshCw className="size-5 shrink-0 text-white" />
        <p className="flex-1 text-sm text-white">
          <span className="font-semibold">A new version is available.</span> Reload to get the latest features and
          fixes.
        </p>
        <Button onClick={onReload} variant="secondary" size="sm" data-testid="update-reload">
          <RefreshCw className="mr-1 size-4" />
          Reload
        </Button>
        <button
          onClick={onDismiss}
          className="
            rounded-sm p-1 text-white
            hover:bg-action-primary-hover
          "
          aria-label="Dismiss update notification"
          data-testid="dismiss-update-notification"
        >
          <X className="size-4" />
        </button>
      </div>
    </div>
  );
}
